const feedbackFactory = context => {
  return {
    get list () { return context.$store.getters.__feedbacks },

    delay (delay) {
      context.$store.dispatch('FEEDBACK_DELAY', delay)
    },

    add (feedbacks) {
      context.$store.dispatch('FEEDBACKS_ADD', feedbacks)
    },

    remove (feedback) {
      context.$store.dispatch('FEEDBACK_REMOVE', feedback)
    }
  }
}

export default feedbackFactory
